import {Button, ButtonProps, Grid, PlusInvertIcon, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {memo} from 'react'

import * as classes from './PaymentCardAddButton.classes'

export const PaymentCardAddButton = memo(function PaymentCardAddButton(props: ButtonProps): React.ReactElement {
  const {disabled, ...buttonProps} = props
  const t = useI18n()

  return (
    <Button className={classes.button} disabled={disabled} variant="outline" fullWidth {...buttonProps}>
      <Grid size="s" container>
        <Grid className={classes.icon} component={PlusInvertIcon} xs={12} item />
        <Grid xs={12} item>
          {disabled ? (
            <Grid size="xs" container>
              <Grid xs={12} item>
                {t('card_list_form.error_message')}
              </Grid>
              <Grid xs={12} item>
                <Typography group="normal" variant="caption1">
                  {t('card_list_form.alert_message')}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            t('card_list_form.add_new_card')
          )}
        </Grid>
      </Grid>
    </Button>
  )
})
